import { Button, cn, Li, Span } from '@scatterlab/zeta-core';
import {
  ComponentPropsWithoutRef,
  ComponentType,
  createElement,
  ElementType,
  memo,
  SVGProps,
} from 'react';

export type DropdownMenuItemProps<
  Component extends ElementType = typeof Button,
> = ComponentPropsWithoutRef<Component> & {
  component?: Component;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  iconClassName?: string;
  content?: string;
  first?: boolean;
  last?: boolean;
};

const DropdownMenuItem = <Component extends ElementType = typeof Button>({
  component,
  icon,
  iconClassName,
  content,
  className,
  first,
  last,
  ...props
}: DropdownMenuItemProps<Component>) => (
  <Li
    className={cn(
      'border-x border-b border-x-white/[8%] border-b-gray-800 transition-colors hover:bg-gray-700',
      {
        'rounded-t-[12px] border-t border-t-white/[8%]': first,
        'rounded-b-[12px] border-b border-b-white/[8%]': last,
      },
    )}
  >
    {createElement(
      component ?? Button,
      {
        className: cn(
          'flex h-[46px] w-full cursor-pointer flex-row items-center gap-2 bg-transparent px-4',
          className,
        ),
        ...props,
      },
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {props.children ? (
          props.children
        ) : (
          <>
            {icon &&
              createElement(icon, { className: cn('w-4', iconClassName) })}
            <Span className="button14 text-gray-300">{content}</Span>
          </>
        )}
      </>,
    )}
  </Li>
);

export default memo(DropdownMenuItem) as typeof DropdownMenuItem;
